import { translate } from "@helpers/translationObjectFormatter";
import styles from "./style.module.scss";
import { useQuery } from "@tanstack/react-query";
import { TranslationsObject } from "@genericTypes/sharedTypes";

export default function ListOfContentsMobile({
    contents,
}: {
    contents: { title: string | null; link: string }[];
}) {
    const { data: translations } = useQuery<TranslationsObject>([
        "translations",
    ]);
    return (
        <section className="lg:hidden  mt-14">
            <h3 className={`text-xl font-bold mb-4`}>
                {translate(translations, "several_general_contents")}
            </h3>
            <div
                className={`${styles["linksList"]}  ${
                    contents?.length >= 3
                        ? "max-h-[180px] overflow-y-auto "
                        : ""
                } `}
            >
                {contents?.map((el, index) => (
                    <div
                        key={index}
                        className={`${styles["bulletedListItem"]} pl-5  rtl:pr-4 before:rtl:right-[5px] before:ltr:left-[5px] pb-3  `}
                    >
                        <a
                            href={el?.link ?? "#"}
                            dangerouslySetInnerHTML={{
                                __html: el?.title as string,
                            }}
                            className={`${styles["linkColor"]}  before:rtl:right-[2px] before:ltr:left-[2px] block  cursor-pointer text-sm `}
                        />
                    </div>
                ))}
            </div>
        </section>
    );
}
